import React from 'react';
import './css/style.min.css';
import BeforeApp from "./BeforeApp";
import Store from './store/configureStore'
import { Provider } from 'react-redux'
import { BrowserRouter as  Router } from 'react-router-dom';

export default function App() {

    return (
        <Provider store={Store}>
            <Router>
                <BeforeApp/>
            </Router>
        </Provider>
    );
}